<template>
  <div class="menu-management">
    <menuManageTopbar @searchMenu="searchMenu" />
    <!-- 列表栏容器 -->
    <div class="menu-info-table-container" v-bitmap="menuListGetResult">
      <menuList class="menu-list" :menuData="menuData" v-show="total" />
    </div>
    <!-- 分页容器 -->
    <!-- <div class="menu-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange"
      />
    </div> -->
  </div>
</template>

<script>
import menuManageTopbar from "./components/menu-manage-topbar/menuManageTopbar.vue";
import menuList from "./components/menu-list/menuList.vue";
export default {
  data() {
    return {
      menuListGetResult: "success",
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 1,
      menuData: [],
      menuName: "",
    };
  },
  components: {
    menuManageTopbar,
    menuList,
  },
  provide() {
    return {
      refresh: this.selectMenuBySchoolId,
    };
  },
  created() {
    this.selectMenuBySchoolId();
  },
  methods: {
    searchMenu(e) {
      this.menuName = e;
      this.selectMenuBySchoolId();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.selectMenuBySchoolId();
    },
    selectMenuBySchoolId() {
      // this.menuListGetResult = "loading";
      let data = {
        schoolId: this.user.schoolId,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        menuName: this.menuName,
      };
      this.get(this.$url.selectMenuBySchoolId, data).then((res) => {
        // console.log("获取学校功能菜单列表==>", res);
        if (res.code != 200) {
          this.menuListGetResult = "error";
          return this.$message.error("获取菜单列表失败");
        }
        let menuList = res.data;
        // 遍历menuList数组，将子菜单添加到对应的父菜单的childMenu属性中
        menuList.forEach((menu) => {
          menu["label"] = menu.menuName;
          menu["value"] = menu.id;
          const parentId = menu.parentId;
          if (parentId !== 0) {
            const parentMenu = menuList.find((item) => item.id === parentId);
            if (parentMenu) {
              if (!parentMenu.childMenu) {
                parentMenu.childMenu = [];
              }
              if (menu.menuType == "M") {
                parentMenu.children = [];
                parentMenu.children.push(menu);
              }
              if (menu.menuType == "F") {
                return;
              }
              parentMenu.childMenu.push(menu);
            }
          }
        });

        // 使用 filter 方法过滤掉不需要的对象
        this.menuData = menuList.filter((menu) => menu.parentId === 0);
        // let data = menuList.find((item) => item.menuName === "系统管理");
        // console.log("this.menuData==>", this.menuData, menuList);
        this.total = res.data.length;
        this.total > 0
          ? (this.menuListGetResult = "success")
          : (this.menuListGetResult = "nullData");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./menuManagement.scss";
</style>
